if (!customElements.get('bb-product')) {
  customElements.define('bb-product', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-bb-viewport]');
      this.thumbs = [...this.querySelectorAll('[data-bb-thumb]')];
      this.thumbs.forEach((b) => b.addEventListener('click', () => this.goTo(b.dataset.bbThumb)));
      this.querySelectorAll('[data-bb-arrow]').forEach((b) => b.addEventListener('click', () => this.step(b.dataset.bbArrow === 'next' ? 1 : -1)));
      if (this.viewport) {
        this.viewport.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.syncThumbs(), 80);
        }, { passive: true });
      }
      this.inputs = [...this.querySelectorAll('input[data-bb-variant]')];
      this.inputs.forEach((input) => input.addEventListener('change', () => this.onVariant(input, false)));
      const checked = this.inputs.find((i) => i.checked);
      if (checked) this.onVariant(checked, true);
    }
    slides() { return this.viewport ? [...this.viewport.querySelectorAll('[data-bb-slide]')] : []; }
    goTo(id) {
      const slide = this.viewport && this.viewport.querySelector(`[data-bb-slide="${id}"]`);
      if (!slide) return;
      this.viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
    step(dir) {
      const slides = this.slides();
      if (!slides.length) return;
      const index = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
      const next = (index + dir + slides.length) % slides.length;
      this.goTo(slides[next].dataset.bbSlide);
    }
    syncThumbs() {
      const slides = this.slides();
      if (!slides.length) return;
      const index = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
      const id = slides[index] && slides[index].dataset.bbSlide;
      this.thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.bbThumb === id));
    }
    onVariant(input, initial) {
      const d = input.dataset;
      this.querySelectorAll('[data-bb-price]').forEach((el) => { el.innerHTML = d.price; });
      this.querySelectorAll('[data-bb-compare]').forEach((el) => { el.innerHTML = d.compare || ''; });
      this.querySelectorAll('[data-bb-pp]').forEach((el) => { el.innerHTML = d.pp || ''; });
      const available = d.available === 'true';
      this.querySelectorAll('[data-bb-atc]').forEach((btn) => {
        const label = btn.querySelector('.button-text');
        if (available) {
          btn.removeAttribute('disabled');
          if (label && btn.dataset.label) label.textContent = btn.dataset.label;
        } else {
          btn.setAttribute('disabled', 'disabled');
          if (label) label.textContent = btn.dataset.soldout;
        }
      });
      if (!initial) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url.toString());
        if (d.media) this.goTo(d.media);
      }
      document.dispatchEvent(new CustomEvent('bb:variant', { detail: { id: input.value, price: d.price, available } }));
    }
  });
}